import { createApiSlice } from "@common";
import { CRUD_INFLUENCE_LEVEL } from "@routes";

const apiConfig = [
  {
    name: "addInfluenceLevel",
    method: "post",
    url: CRUD_INFLUENCE_LEVEL,
    stateKey: "message"
  },
  {
    name: "getInfluenceLevel",
    method: "get",
    url: CRUD_INFLUENCE_LEVEL,
    stateKey: "data"
  },
  {
    name: "updateInfluenceLevel",
    method: "put",
    url: CRUD_INFLUENCE_LEVEL,
    stateKey: "message"
  },
  {
    name: "deleteInfluenceLevel",
    method: "delete",
    url: CRUD_INFLUENCE_LEVEL,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: []
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "influenceLevel",
  apiConfig,
  customReducers);
const influenceLevelSlice = slice;

export default influenceLevelSlice.reducer;

export const {
  addInfluenceLevel,
  getInfluenceLevel,
  updateInfluenceLevel,
  deleteInfluenceLevel

} = thunks;
export const { rowSelect } = actions;
